<div>
    <!-- <div>
        <button mat-raised-button class="btn-nueva" (click)="crearCuentaJardin()"><mat-icon>add</mat-icon> Crear Cuenta</button>
        <mat-form-field class="filtro-input">               
            <input matInput #palabraClave type="search" placeholder="Palabra clave...">
            <button mat-button matSuffix mat-stroked-button aria-label="search" (click)="buscar(palabraClave)">
            Buscar
        </button>
        </mat-form-field>
    </div> -->
    <div class="row">
        <div class="d-flex justify-content-end">
            <button (click)="crearCuentaJardin()" class="btn " style="background-color: #597CEE; height: 38px;color: #FFFFFF; margin-top: -30px; "><i class="fas fa-plus"></i> Crear Cuenta</button>
        </div>
    </div>
    <div class="row" style="margin-top: 20px;">
        <div class="col-lg-1">
            <p class="title-descriptor">Filtrar Por:</p>
        </div>
        <div class="col-lg-2">
            <mat-form-field>
                
                <mat-label>Región</mat-label>
                <mat-select id="region" name="region" class="selectMedio"  (selectionChange)="seleccionarRegion($event.value)">
                    <mat-option [value]="0">Seleccione Región</mat-option>
                    <mat-option [value]="regiones.idRegion" *ngFor="let regiones of infoSelectJardin.regiones">{{regiones.nombre}}</mat-option>
                </mat-select>
            </mat-form-field>  
        </div>
        <div class="col-lg-2">
            <mat-form-field>
                <mat-label>Comuna</mat-label>
                <mat-select id="comuna" class="selectMedio" name="comuna" (selectionChange)="seleccionarComuna($event.value)">
                    <mat-option [value]="0">Seleccione Comuna</mat-option>
                    <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
                </mat-select>
                <!-- <mat-error *ngIf="hasError('comuna', 'required')">Comuna es requerido</mat-error>
                <mat-error *ngIf="hasError('comuna', 'min')">Comuna es requerido</mat-error> -->
            </mat-form-field>   
        </div>
        <div class="col-lg-2">
            <mat-form-field>
                <mat-label>Programa</mat-label>
                <mat-select  placeholder="" floatlLabel="never" id="programa" class="selectMedio" name="programa" (selectionChange)="seleccionarPrograma($event.value)">
                    <mat-option value="0">Seleccione Programa</mat-option>
                    <mat-option [value]="programas.idTablaMaestra" *ngFor="let programas of infoSelectJardin.programas">{{programas.descripcionLarga}}</mat-option>
                </mat-select>
                <!-- <mat-error *ngIf="hasError('programa', 'required')">Programa es requerido</mat-error> -->
            </mat-form-field>
        </div>
        <div class="col-lg-5 d-flex justify-content-end" >
          <input class="form-control me-sm-2" type="text" (keyup.enter)="buscar(palabraClave)" [(ngModel)]="palabraClave" style="width: 300px; height: 45px;" placeholder="Buscar">
                  <button class="btn btn-secondary" type="submit" (click)="buscar(palabraClave)" style="width: 130px;height: 45px;"><i class="fas fa-search"></i> Buscar</button>
        </div>
      </div>
      <div class="row">
        <div class="d-flex justify-content-end">
            <a class="btn" [attr.href]="apiEndpoint + 'adminUsuarioInformes/1'" target=”_blank”  style="width: 40px;border-radius: 50%;background-color: #597CEE;color: #fff;"> <i class="fas fa-download"></i> </a>
        </div>
      </div>
    <div>
    <!-- <div class="example-loading-shade"
            *ngIf="isLoadingResults">
        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
    </div> -->

        <table class="tables-info" mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef > Región </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.region}} </td>
            </ng-container>

            <ng-container matColumnDef="comuna">
                <th mat-header-cell *matHeaderCellDef > Comuna </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.comuna}} </td>
            </ng-container>

            <ng-container matColumnDef="programa">
                <th mat-header-cell *matHeaderCellDef > Programa </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.programa}} </td>
            </ng-container>

            <ng-container matColumnDef="modalidad">
                <th mat-header-cell *matHeaderCellDef > Modalidad </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.modalidad}} </td>
            </ng-container>

            <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef > Código JI </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.codigo}} </td>
            </ng-container>

            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef > Nombre JI </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.nombre}} </td>
            </ng-container>
            
            <ng-container matColumnDef="usuario">
                <th mat-header-cell *matHeaderCellDef > Usuario</th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.usuario}} </td>
            </ng-container>

            <ng-container matColumnDef="pass">
                <th mat-header-cell *matHeaderCellDef > Clave</th>
                <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.pass}} </td>
            </ng-container>

            <ng-container matColumnDef="bloqueo">
                <th mat-header-cell *matHeaderCellDef > Bloqueo</th>
                <td mat-cell *matCellDef="let row">                  
                    <mat-checkbox class="example-margin" [(ngModel)]="row.bloqueo" (change)="bloquear(row, 'us_jardin')">
                    <span class="material-icons closed" *ngIf="row.bloqueo">lock</span>
                    <span class="material-icons open" *ngIf="!row.bloqueo">lock_open</span>                        
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef > Acciones</th>
                <td mat-cell *matCellDef="let row; let i = index"> 
                    <button mat-mini-fab class="btn-eliminar" (click)="editarCuentaJardin(row, i)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-mini-fab class="btn-eliminar" (click)="verCuentaJardin(row)">
                        <mat-icon>search</mat-icon>
                    </button>
                    <button mat-mini-fab class="btn-eliminar" (click)="simular(row)">
                        <mat-icon>login</mat-icon>
                    </button>
                    <button mat-mini-fab class="btn-editar" (click)="abrirPlanMejora(row)">
                        <mat-icon>lock_open</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            
            [pageSizeOptions]="[10, 50, 100]"
            [showFirstLastButtons]="true"
            (page)="getServerData($event)">
        </mat-paginator>
    </div>
</div>

<ngx-spinner></ngx-spinner>